import { z } from 'zod';
import { dateSchema } from '../../validation';

export const orderFromToDateSchema = z.object({
  /** the minimum date to pickup or dropoff  */
  from: dateSchema,
  /** the last date to pickup or dropoff  */
  to: dateSchema,
});
export type OrderFromToDate = z.infer<typeof orderFromToDateSchema>;

export const orderDropoffExpectationSourceSchema = z.enum(['user', 'distance']);
export type OrderDropoffExpectationSource = z.infer<typeof orderDropoffExpectationSourceSchema>;

export const orderDatesSchema = z.object({
  /** the pickup time entered by the user */
  pickup: orderFromToDateSchema,
  /**
   * the expected delivery to the user
   *
   * if empty, the it means we do not yet have an expectation
   */
  dropoffExpectation: orderFromToDateSchema.optional(),
  /**
   * Who set `dropoffExpectation`: `user` when a person stated it (a date,
   * a trip length, «لين يوم 16»), `distance` when the backend estimated
   * it from the route at 500 km a day. Missing on older orders — read as
   * `distance`. A government waybill files its own 5-day default unless
   * this is `user` (`resolveBayanTripDates`).
   */
  dropoffExpectationSource: orderDropoffExpectationSourceSchema.optional(),


  /** the date at which the order was delivered. it will be the same as event 'delivered' in the timeline */
  deliveredAt: dateSchema.optional(),
});
export type OrderDates = z.infer<typeof orderDatesSchema>;
